import styled from 'styled-components';

export const ProfileContainer = styled.div`
  width: 100%;
  max-width: 500px;
  padding: 20px 20px;
  display: flex;
  /* justify-content: space-between; */
  gap: 30px;
  align-items: center;
  background-color: #f0f0f0;
  border-radius: 5px;
  margin-bottom: 30px;
  /* gap: 10px; */
  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    padding: 10px 10px;
    min-width: 390px;
  }

  & .btn-upload {
    height: 30px;
    width: auto;
    padding: 10px 4px;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    align-items: center;
  }

  & .mail {
    color: #8a8a8a;
  }
`;

export const PersonalInformationWrapper = styled.div`
  max-width: 500px;
`;
